<template>
  <div class="BackgroundBox">
    <div class="Box">
      <div class="FileList limitBox">
        <!-- <div>
          <NewsComp :NewsCompConfig="state.NewsCompConfig" :pageN="5"></NewsComp>
        </div> -->
        <div>
          <div class="DisplayFlex">
            <div class="mainTitle">
              <p>{{ state.VideosCompConfig.title }}</p>
              <p>{{ state.VideosCompConfig.eTitle }}</p>
            </div>
            <div class="SeeMore">
              <p>
                <span
                  @click="toMore"
                  >查看更多</span
                >
                <span class="iconfont iconarrowright"></span>
              </p>
            </div>
          </div>

          <!-- 列表 -->
        <div class="CulturalList">
            <div
              v-for="(item, index) in state.dataList"
              :key="index"
              class="CulturalItem"
            >
              <div v-if="item.img">
                <el-image
                  :src="item.img"
                  fit="cover"
                  class="cuImage"
                  @click="GoToDetails(item)"
                  style="width: 100%; height: 160px"
                >
                  <template #error>
                    <div class="image-slot">
                      <span>加载中</span>
                    </div>
                  </template>
                </el-image>
              </div>
              <div v-else>
                <el-image
                  :src="require('../img/logo.png')"
                  fit="contain"
                  class="cuImage"
                  @click="GoToDetails(item)"
                  style="width: 100%; height: 160px"
                >
                  <template #error>
                    <div class="image-slot">
                      <span>加载中</span>
                    </div>
                  </template>
                </el-image>
              </div>
              <div>
                <p @click="GoToDetails(item)">{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Vue from "vue";
import router from "@/router";
import api from "@/comment/request/api";
import NewsComp from "../Components/NewsComp";

export default {
  name: "Video",
  components: { NewsComp },
  setup(props, { attrs, slots, emit }) {
    const state = Vue.reactive({
      VideosCompConfig: {
        // url: '/info/news/index',
        title: "视频风采",
        eTitle: "Videos",
        // path: '/Video',
        // detail: 'NewsDetails',
        // id: 'news_id',
        // cate_id: 5,
      },
      PageConfig: {
          currentPage: 1,
          total: 10,
          pageNum: 4,
        },
        dataList: [],
        title: '',
    });

    const toMore = (item) => {
      router.push({
        name: "Video",
        query: { },
      });
    };
    //跳转详细
    const GoToDetails = (item) => {
        router.push({
          name: "VideoDetails",
          query: {
            id: item.videos_id,
          },
        });
      };
    //获取视频列表
    const getDataList = () => {
        const params = {
          page: state.PageConfig.currentPage,
          limit: state.PageConfig.pageNum,
          cate_id: state.cate_id,
          title: state.title,
        };
        api.GetDataList('/info/videos/index', params).success((res) => {
          state.dataList = res.data.data.data;
          state.PageConfig.total = parseInt(res.data.data.total);
        });
      };
      getDataList();
    return {
      state,
      toMore,
      GoToDetails,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "/src/comment/comment";

.Box {
  position: relative;
  overflow: hidden;
}
.FileList {
  padding-top: 40px;
  padding-bottom: 40px;
  display: flex;
  justify-content: space-between;
  > div:first-child {
    // width: calc(33% - 30px);
    width: 100%;
    //头部
    .DisplayFlex {
    border-bottom: 5px solid #d8d8d8;
    position: relative;
    }
    .NoBottom {
      border-bottom: none;
      display: flex;
      align-items: center;
      /deep/.SeeMore {
        bottom: auto;
      }
    }
    .mainTitle {
      width: calc(100% - 100px);
      margin-top: 12px;
      //margin-left: 30px;
      padding-bottom: 10px;
      line-height: 24px;
    }
    .topicTitle {
      display: flex;
      > p {
        margin-right: 10px;
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        line-height: 24px;
        margin-bottom: 10px;
        color: #d8d8d8;
        cursor: pointer;
      }
      .active {
        color: #008fd7;
      }
      > p:not(p:last-child):after {
        content: "|";
        color: #d8d8d8;
        font-weight: lighter;
        margin-left: 10px;
      }
    }
    .topicTitleTwo {
      width: 100%;
      background-color: #f1f1f1;
      display: flex;
      padding-left: 20px;
      p {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 22px;
        margin: 4px;
        padding: 9px 20px;
        cursor: pointer;
      }
      .active {
        font-weight: 600;
        color: #008fd7;
        background-color: #ffffff;
      }
    }
    .SeeMore {
      width: 100px;
      position: absolute;
      right: 0;
      bottom: 5px;
    }

    //视频数据
    .CulturalList {
      display: flex;
      // justify-content: space-between;
      // flex-wrap: wrap;
      // border-top: 5px solid #008fd7;
  
      .CulturalItem {
        width: calc(25% - 15px);
        // margin-top: 40px;
        margin-top: 20px;
        background-color: white;
        border-radius: 4px;
        //border: 1px solid rgba(0, 0, 0, 0.15);
        margin-right: 20px;
        &:nth-child(4n) {
          margin-right: 0;
        }
        > div:nth-child(1) {
          padding: 10px;
        }
  
        > div:nth-child(2) {
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          padding: 0 10px 10px 10px;
  
          p {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            cursor: pointer;
            &:hover {
              color: #008fd7;
            }
          }
        }
  
        > div:nth-child(3) {
          padding: 10px;
          overflow: hidden;
          height: 30px;
          line-height: 12px;
  
          p {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
  
          p:nth-child(1) {
            float: left;
          }
  
          p:nth-child(2) {
            flex: 0 1 auto;
            float: right;
            span:nth-child(2) {
              margin-right: 15px;
            }
            span {
              margin-left: 3px;
            }
          }
        }
      }
    }
  }

  

}
</style>